// eslint-disable-next-line
export const aiToolsIds = {
  VIDEO_SCRIPTWRITER: 'video_scriptwriter',
  FACE_SWAP: 'face_swap',
  BACKGROUND_REMOVER: 'background_remover',
  STYLE_TRANSFER: 'style_transfer',
  IMAGE_VARIATIONS: 'image_variations',
  VIDEO_UPSCALER: 'video_upscaler',
  // coming soon
  IMAGE_TO_VIDEO: 'image_to_video',
  IMAGE_GENERATOR: 'image_generator',
  IMAGE_ENHANCER: 'image_enhancer',
  MUSIC_DURATION_ADJUSTER: 'music_duration',
  //
  BUSINESS_ILLUSTRATION: 'business_illustration',
  TEXT_TO_ILLUSTRATION: 'text_to_illustration',
};
